import InvitedMembersTable from './InvitedMembersTable';
export default InvitedMembersTable;
